import React from 'react'
import { camelCaseToReadable } from '../../../util/StringUtil'
import MoreMetadataButton from '../../common/buttons/MoreMetadataButton'
import TreeChangesMoreMetadataDialog from './TreeChangesMoreMetadataDialog'

export default function TreeChangesTableDetailsColumn({
  contribution,
  personIdFields,
  relationshipIdFields,
  metadataFields,
}) {
  return Object.entries(contribution)
    .filter(
      ([key]) => !relationshipIdFields.includes(key) && !personIdFields.includes(key) && !metadataFields.includes(key)
    )
    .map(([key, value]) => {
      return (
        <div key={`${key}_${contribution.type}_${contribution.modified}`}>
          <strong>{camelCaseToReadable(key)}: </strong>
          <span>
            {value instanceof Object ? (
              <MoreMetadataButton metadata={value} MetadataDialog={TreeChangesMoreMetadataDialog} />
            ) : (
              value
            )}
          </span>
        </div>
      )
    })
}
